// extracted by mini-css-extract-plugin
export default {"header":"ancillaries-list_header__bCYfb","buttonWrapper":"ancillaries-list_buttonWrapper__YTHqh","list":"ancillaries-list_list__l+7+0","listItem":"ancillaries-list_listItem__I03li"};